import { GetterTree } from "vuex";
import { GuardStatus, Mobile } from "./types";
import { RootState } from "../types";
import wait from "@/utils/wait";
import Vue from "vue";

export const getters: GetterTree<Mobile, RootState> = {
	getCallSign: state => state.DispatchGuard.callSign,
	getOnDuty: state => state.DispatchGuard.onDuty,
	getIsCoverAvailable: state => state.DispatchGuard.isCoverAvailable,
	getIsRightSidebarOpen: state => state.DispatchGuard.isRightSideBarOpen,
	getIsLeftSidebarOpen: state => state.DispatchGuard.isLeftSideBarOpen,
	getGuardId: state => state.DispatchGuard.guardId,
	getUnavailableReason: state => state.DispatchGuard.unavailableReason,
	getUnavailableStatus: state => state.DispatchGuard.unavailableStatusId,
	getShowDirections: state => state.MobileUser.showDirections,
	getHasArrived: state => state.DispatchGuard.hasArrived,
	getStatus: state => {
		switch (state.DispatchGuard.statusEnum) {
			case GuardStatus.Available:
				return "Available"
			case GuardStatus.Dispatched:
				return "Dispatched"
			case GuardStatus.Arrived:
				return "Arrived"
			case GuardStatus.Unavailable:
				return "Unavailable"
			case GuardStatus.EnRoute:
				return "En Route"
			case GuardStatus.Covered:
				return "Available"
			case GuardStatus.Covering:
				return "Covering"
			case GuardStatus.CoveringRequested:
				return "Requested to Cover"
		}
		return ""
	},
	getCallSigns: state => state.CallSigns,
	getDeviceLocation: state => state.DeviceLocation,
	getDispatchRequests: state => state.DispatchRequests,
	getDispatchRequest: state => (dispatchRequestId: number) => {
		let dispatchRequest = state.DispatchRequests.find(dispatchRequest => {
			return dispatchRequest.dispatchQueueID === dispatchRequestId;
		});

		return dispatchRequest;
	},
	getFocalPoint: state => state.FocalPoint,
	getClaimedDispatchRequests: state => {
		return state.DispatchRequests.filter(dispatchRequest => {
			return dispatchRequest.claimed;
		}).sort(function (a, b) {
			// Put the active dispatch request at the top
			return a.active ? -100 : 100;
		});
	},
	getUnclaimedDispatchRequests: state => {
		return state.DispatchRequests.filter(dispatchRequest => {
			return !dispatchRequest.claimed;
		});
	},
	getActiveDispatchRequest: state => {
		return state.DispatchRequests.find(element => {
			return element.active;
		});
	},
	getAuditEndpoint: state => state.AuditEndpoint,
	getMobileFeatures: state => state.MobileFeatures,
	getDispatchNotesForEvent: state => {
		return state.DispatchNotesForEvent;
	},
	getProximityCallSigns: state => state.ProximityCallSigns,
	getMobileGuardsForEvent: state => state.MobileGuardsForEvent,
	getUnavailableStatuses: state => state.UnavailableStatuses,
	getLiveDeviceId: state => state.LiveDevice.deviceID,
	getStarredDevices: state => state.StarredDevices,
	getEvents: state => state.ManageEvents,
	getWatchedDeviceLocation: state => async (timeOut: number) => {
		let elapsedTime = 0;
		const delayMs = 10;

		if (state.DeviceLocation) {
			return state.DeviceLocation
		}

		while (elapsedTime < timeOut) {
			await wait(delayMs);
			if (state.DeviceLocation) {
				return state.DeviceLocation
			}
			elapsedTime += delayMs;
		}

		throw new Error("getWatchedDeviceLocation timed out");
	},
	getAvailableButtonDisabled: state=> {
		return state.LeftSidebar.CoverPickerShown || state.LeftSidebar.HasCoverRequest
	},
	getCoverButtonDisabled: state=> {
		return state.CoverCallSigns.length == 0 ||
			state.LeftSidebar.UnavailablePickerShown||
			state.LeftSidebar.HasCoverRequest
	},
	getGuardStatusMobile: state => (guardId: number) => {
		let result = 0;
		const guard = state.MobileGuardsForEvent.find(guard => guard.guardID === guardId);

		if(guard != null)
			result = guard.status;
		return result;
	}
};
